jQuery(function($) {
    $( document ).ready(function() {
  
        partnersListGrid();
  
        function partnersListGrid() {
            var partnersGrid = document.querySelector('.partnersList');
            var counter = 0;
            
            if(partnersGrid) {
                var partners = partnersGrid.querySelectorAll('.partner');
    
                partners.forEach(function(partner) {
                    counter++;
    
                    let openIcon = partner.querySelector('#open-icon');
                    let closeIcon = partner.querySelector('#close-icon');
                
                    openIcon.addEventListener('click' , function() {
                        hamletMembersClose(partners);
                        hamletMemberOpen(partner , openIcon , closeIcon);
                        hamletMembersStyles(partners);
    
                    })
                
                    closeIcon.addEventListener('click' , function() {
                        hamletMemberClose(partner , openIcon , closeIcon);
                        hamletMembersResetStyles(partners);
                    })

                    if(window.innerWidth >= 1024) {
                        if (counter % 4 === 0) {
                            addDropdownContent(partner); 
                            addLastDropdownContent();
                        }
                    } else if (window.innerWidth >= 767 && window.innerWidth < 1024) {
                        if (counter % 2 === 0) {
                            addDropdownContent(partner); 
                            addLastDropdownContent();
                        }
                    } else if (window.innerWidth < 767) {
                        if (counter % 1 === 0) {
                            addDropdownContent(partner); 
                        }
                    }
                
    
                })
            }
        }

        // ADD DROPDOWN CONTENT
        function addDropdownContent(partner) {

            var dropdownContent = document.createElement('div');
            dropdownContent.classList.add('dropdown-content');
            partner.parentNode.insertBefore(dropdownContent, partner.nextSibling);
            
        }

        // ADD DROPDOWN CONTENT IF LAST ELEMENT IS NOT DROPDOWN
        function addLastDropdownContent() {
            let partners = document.querySelector('.hamlet-family .partners');
            let newMembers = document.querySelectorAll('.hamlet-family .partners > *');
            let length = newMembers.length;
            let lastIndex = length - 1;
            let lastElement = newMembers[lastIndex];
            
            if(!lastElement.classList.contains('dropdown-content')) {
                var dropdownContent = document.createElement('div');
                dropdownContent.classList.add('dropdown-content');
                partners.appendChild(dropdownContent);
            } 
        }

  
        // OPEN ONE partner
        function hamletMemberOpen(partner, openIcon, closeIcon) {
    
            openIcon.style.display = "none";
            closeIcon.style.display = "block";
            partner.classList.add('active');

            let content = partner.querySelector('.contenu').innerHTML;
            let dropdown = findDropdown(partner);

            if (dropdown) {
                // let dropdownContent = dropdown.querySelector('p');
                dropdown.innerHTML = content;
                dropdown.classList.add('open');
            }
        }

        // CLOSE ONE partner
        function hamletMemberClose(partner , openIcon , closeIcon) {

            partner.classList.remove('active');
            openIcon.style.display = "block";
            closeIcon.style.display = "none";

            var dropdownContent = findDropdown(partner);

            if (dropdownContent) {
                dropdownContent.classList.remove('open');
            }
        }

        // CLOSE ALL partners
        function hamletMembersClose(partners) {

            let dropdown = document.querySelector('.dropdown-content');
            dropdown.classList.remove('open');

            partners.forEach(function(partner) {
                let openIcon = partner.querySelector('#open-icon');
                let closeIcon = partner.querySelector('#close-icon');
                openIcon.style.display = "block";
                closeIcon.style.display = "none";
                partner.classList.remove('active');
        
            })
            let dropdowns = document.querySelectorAll('.hamlet-family .dropdown-content');
       
            dropdowns.forEach(function(dropdown) {
                dropdown.classList.remove('open');
            })
            hamletMembersStyles(partners);
        }
    
        // UPDATE Styles ON partners 
        function hamletMembersStyles(partners) {
    
            hamletMembersResetStyles(partners);
    
            partners.forEach(function(partner) {
                let img = partner.querySelector('img');
                let titleWrapper = partner.querySelector('.title-wrapper');
                let title = titleWrapper.querySelector('h4');
                let openIcon = titleWrapper.querySelector('#open-icon');

                if(!partner.classList.contains('active')) {
                    title.style.color = "grey";
                    openIcon.style.color = "grey";

                    if(img) {
                        img.style.filter = "blur(10px)";
                        title.style.filter = "blur(10px)";
                        openIcon.style.filter = "blur(10px)";
                    }
                }

            })
        }

        // RESET ALL partners COLOR
        function hamletMembersResetStyles(partners) {
    
            partners.forEach(function(partner) {
                let titleWrapper = partner.querySelector('.title-wrapper');
                let title = titleWrapper.querySelector('h4');
                let openIcon = titleWrapper.querySelector('#open-icon');
                let img = partner.querySelector('img');

                // RESET COLORS
                title.style.color = "initial";
                openIcon.style.color = "initial";


                if(img) {
                    title.style.color = "black";
                    openIcon.style.color = "black";
                    img.style.filter = "blur(0px)";
                    title.style.filter = "blur(0px)";
                    openIcon.style.filter = "blur(0px)";
                }
                
            })
        }

        function findDropdown(partner) {
            var nextSibling = partner.nextSibling;
            while (nextSibling) {
                if (nextSibling.classList && nextSibling.classList.contains('dropdown-content')) {
                    return nextSibling;
                }
                nextSibling = nextSibling.nextSibling;
            }
            return null;
        }
  
    });
});
  
  
  